import { render, staticRenderFns } from "./PublicResetPassword.vue?vue&type=template&id=7a77b3d0&"
import script from "./PublicResetPassword.vue?vue&type=script&lang=js&"
export * from "./PublicResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./PublicResetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports